module.exports = __webpack_public_path__ + "img/2.a727325d.jpg";